import { ChevronDown } from 'lucide-react';

import type { NavSection } from '@/lib/types';
import { cn } from '@/lib/utils';

import { NavRow } from './nav-row';

/** Full-width (labelled) rendering of one nav section. */
export function NavSectionBlock({
  section,
  isOpen,
  onToggle,
  counts,
}: {
  section: NavSection;
  isOpen: boolean;
  onToggle: () => void;
  counts: Record<string, number>;
}) {
  if (!section.items.length) return null;

  const expanded = !section.collapsible || isOpen;

  return (
    <div className={cn('flex flex-col gap-0.5', section.separator && 'mt-1 border-t border-line pt-2')}>
      {section.title ? (
        section.collapsible ? (
          <button
            type="button"
            onClick={onToggle}
            aria-expanded={expanded}
            className="flex items-center gap-1 rounded px-2 py-1 text-[10px] font-semibold uppercase tracking-wider text-ink-4 transition-colors hover:text-ink-3 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-primary"
          >
            <ChevronDown className={cn('size-3 transition-transform', !expanded && '-rotate-90')} />
            {section.title}
          </button>
        ) : (
          <span className="px-2 py-1 text-[10px] font-semibold uppercase tracking-wider text-ink-4">
            {section.title}
          </span>
        )
      ) : null}

      {expanded
        ? section.items.map((item) => (
            <NavRow
              key={`${item.title}-${item.route ?? item.external_url}`}
              item={item}
              count={item.route ? counts[item.route] : undefined}
            />
          ))
        : null}
    </div>
  );
}
